// import logo from './logo.svg';
import './App.css';
import './style.css';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Werfen from './pages/werfen';

function App() {
  return (
    <div className='vh-100 w-100'>
      <BrowserRouter>
        <Routes>
          <Route
            path="/"
            element={<Werfen />}
          />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
